<template>
  <div class="DiscussionLikeSublist">
    <div id="myNav" class="overlay overlay-overall-width-100Perc">
      <div class="overlay-content center-aligned-div white-porition-overlay-width-95Perc background-color-white margin-bottom-2Perc">  
        <div class="container-fluid">
          <div class=" margin-Top-1Perc">
              <img :src="userclose" alt="usericon2" class="img-responsive float-right cursor-pointer" height="20" width="20" @click="closeOverlay">
          </div>
          <div class="row">
            <div class="col-md-12 col-lg-12 font-size-20px font-wight-bold">
              Likes
            </div>  
          </div>
          <div class="row">
            <div class="col-md-2 col-lg-2 width cursor-pointer font-size-13px padding-left-6px" @click="showUserDetails">
              {{showDetails === false ? 'Show User Details' : 'Hide User Details'}}
            </div>
            <div class="col-md-10 col-lg-10"></div> 
          </div>   
          <div class="row">  
            <discussion-selected-user-details v-bind:selectedDiscussionObj="getSelectedDiscussionObj" v-if="showDetails" v-bind:showComments="true"></discussion-selected-user-details> 
          </div>    
          <sub-sortable-list v-bind:responseObj="getDisscussionLikeList" v-bind:sortableColumnName="sortColumnNames" v-bind:columnNameToShow="columnNameToShow" v-bind:linkColumnName="linkColumnNames"></sub-sortable-list>
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
import close from '../assets/images/close.svg'
import SubSortableList from '@/pages/SubSortableList'
import DiscussionSelectedUserDetails from '@/components/DiscussionSelectedUserDetails'
export default {
  props: ['selectedDiscussionObj', 'likeResp'],
  data: function () {
    return {
      userclose: close,
      sortColumnNames: ['ParticipantName', 'LikedOn'],
      columnAlias: ['Participant', 'Liked On'],
      columnRespKey: ['ParticipantName', 'LikedOn'],
      columnNameToShow: [],
      linkColumnNames: [],
      showDiscussionList: true,
      txtDesc: 'Show User Details',
      showDetails: false
    }
  },
  created: function () {
    this.bindColumnsNameAndAlias()
  },
  methods: {
    closeOverlay: function () {
      this.$emit('showOverlay', false)
    },
    bindColumnsNameAndAlias: function () {
      this.columnNameToShow = []
      for (var i = 0; i < this.columnRespKey.length; i++) {
        var obj = {
          ColumnName: this.columnRespKey[i],
          ColumnAlias: this.columnAlias[i]
        }
        this.columnNameToShow.push(obj)
      }
    },
    showUserDetails: function () {
      this.showDetails = !this.showDetails
    }
  },
  components: {
    'sub-sortable-list': SubSortableList,
    'discussion-selected-user-details': DiscussionSelectedUserDetails
  },
  computed: {
    getDisscussionLikeList: {
      get: function () {
        return this.likeResp
      }
    },
    getSelectedDiscussionObj: {
      get: function () {
        return this.selectedDiscussionObj
      }
    }
  },
  name: 'DiscussionLikeSublist'
}
</script>

<style scoped>
.user-progress {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.width {
  width: 98% !important;
}
.margin-left-2Perc {
  margin-left: 1.8% !important;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.font-size-20px
{
  font-size:20px;
}
.black-border {
  border: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.padding-Left-30px {
  padding-left: 3% !important;
}
.white-BG {
  background-color: #ffffff;
}
.padding-Left-0px {
  padding-left: 0px !important;
}
.padding-right-0px {
  padding-right: 0px !important;
}
.margin-Top-3Perc{
  margin-top: 3% !important;
}
.margin-Top-5Perc{
  margin-top: 5% !important;
}
.margin-left-1Perc{
  margin-left: 1% !important;
}
.padding-bottom-0Perc{
  padding-bottom: 0px; 
}
/* Using Only for footer */
.footer{
  position: fixed;
    left: 38px !important;
    bottom: 0 !important;
    width: 100% !important;
    /* background-color: red; */
    /* color: white; */
    text-align: center !important;
    margin-bottom: 1% !important;
    font-size: 12px !important;
}
.text-align-center {
  text-align: center !important;
}
.overflow-x-hidden {
  overflow-x: hidden !important;
}
.float-right{
float: right;
}
.margin-Top-3Perc {
  margin-top: 3%;
}
.font-size{
  font-size: 17px;
}
.padding-Top-0px {
  padding-top: 0px !important;
}

.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 10%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-95Perc {
  width: 95%;
}
.center-aligned-div {
  margin: 0 auto;
}
/*
.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}
*/
.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  /*.overlay a {
    font-size: 20px;
  }*/
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-17px {
  font-size: 17px !important;
}
.text-align-left {
  text-align: left !important;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.course-img-width-height {
  width: 350px;
  height: 150px;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a {
  color: #2c3e50 !important;
  text-decoration: none !important;
}
.cursor-pointer {
  cursor: pointer;
  }
.font-size-13px{
  font-size:13px !important;
}
.padding-left-6px{
  padding-left:6px !important;
}
.border-right{
    border-right: 1px solid #aaa !important;
}
.width{
  width:14.3% !important;
}
</style>


// WEBPACK FOOTER //
// src/components/DiscussionLikesSublistOverlay.vue